import { PlatformLocation } from '@angular/common';
import { Injectable, Optional } from '@angular/core';
import { ConfigurationService } from '../configuration';

@Injectable({ providedIn: 'root' })
export class CurrentLocationService {
    public url: URL | PlatformLocation;
    private hostnameFromConfig = 'localhost';

    constructor(
        private platformLocation: PlatformLocation,
        @Optional() config: ConfigurationService
    ) {
        this.hostnameFromConfig = config?.get('hostname') || 'localhost:4000';

        this.url = this.getUrl();
    }

    private getUrl() {
        // As it can happen, that Angular does not provide any hostname in PlatformLocation when using the new Vite dev server,
        // we can specify it via a config value
        if (!this.platformLocation.hostname) {
            return new URL('https://' + this.hostnameFromConfig);
        }

        if (this.platformLocation.hostname === 'localhost') {
            const urlToUse = `https://${this.hostnameFromConfig}`;
            return new URL(urlToUse);
        }

        return this.platformLocation;
    }
}
